<div class="di-menu-facturation-preparee">
	<lua-list-item class="list-item" iconColor="Rouge" textColor="Noir" iconName="close"
		text="Annuler la facture préparée" (click)="handleAnnuler()">
    </lua-list-item>
</div>
